const NON_EDITABLE_FILE_BANNER = "// Code generated by Prismic. DO NOT EDIT.";
const CUSTOM_TYPES_LIBRARY_DIRNAME = "customtypes";
const CUSTOM_TYPE_MODEL_FILENAME = "index.json";
const SHARED_SLICE_MODEL_FILENAME = "model.json";
const TSCONFIG_FILENAME = "tsconfig.json";
const GLOBAL_TYPESCRIPT_TYPES_FILENAME = "prismicio-types.d.ts";
export {
  CUSTOM_TYPES_LIBRARY_DIRNAME,
  CUSTOM_TYPE_MODEL_FILENAME,
  GLOBAL_TYPESCRIPT_TYPES_FILENAME,
  NON_EDITABLE_FILE_BANNER,
  SHARED_SLICE_MODEL_FILENAME,
  TSCONFIG_FILENAME
};
//# sourceMappingURL=constants.js.map
